import React from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { CreatableClearableSelector } from '../Selects/CreatableClearableSelector';
import { Option } from '../Selects/Selector';

const DICTIONARY_TYPE = 'Przyczyny korekt';

interface CorrectionReasonSelectorProps {
  value?: string | null;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const CorrectionReasonSelector: React.FC<
  CorrectionReasonSelectorProps
> = ({ value, onChange, readOnly }) => {
  const spd = useSpdCore();

  const provider = async (text: string): Promise<Option[]> => {
    const items = await spd.dictionaries.getByDictionaryType(DICTIONARY_TYPE);
    return items
      .filter(item => item.value.toLowerCase().includes(text.toLowerCase()))
      .map(item => ({
        value: item.value,
        label: item.value,
      }));
  };

  const handleChange = (option: Option) => {
    onChange(option?.value || '');
  };

  return (
    <CreatableClearableSelector
      value={value ?? undefined}
      provider={provider}
      onChange={handleChange}
      readOnly={readOnly}
      placeholder="Wybierz lub wpisz przyczynę korekty..."
    />
  );
};
